module.exports = __webpack_public_path__ + "img/level-mobile2.d6edb9cb.png";